import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { paketWisata } from "../../store/paketWisata";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Footer, Navbar } from "../../components";
import { image1, instagram, youtube } from "../../assets";
import CardImage from "./CardImage";

const DetailPaketWisata = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [paketData, setPaketData] = useState("");
    const [paketOthers, setPaketOthers] = useState("");

    useEffect(() => {
        const paket = paketWisata.find((paket) => paket.id === +id);
        setPaketData(paket);
        setPaketOthers(paket.image_others);
        // if (paket !== 0) {
        // }
    }, [id])

    const handleGoBack = () => {
        navigate(-1);
    }

    console.log(paketOthers);

    return (
        <>
            <Navbar />
            <div className="flex justify-center">
                <div className="container py-24">
                    <div className="flex justify-start pt-8 px-12 py-6 border-b-2 border-b-gray-200">
                        <FontAwesomeIcon className="text-3xl w-8 my-auto cursor-pointer text-green-500" onClick={handleGoBack} icon={faArrowLeft} />
                        <h1 className="my-auto px-12 font-normal text-green-500 text-4xl font-header mx-auto">{paketData.namePaket}</h1>
                    </div>
                    <div className="lg:flex mt-12">
                        <div className="w-1/3 h-full px-8 pb-8 rounded-3xl bg-white shadow-xl">
                            <div className="">
                                <h1 className="lg:text-[280px] text-[200px] font-bold text-gray-300 leading-tight"><span className="text-gray-100">0</span>{paketData.id}</h1>
                            </div>
                            {/* <p>{paketData.image_path}</p> */}
                            <img src={paketData.image_path} className="rounded-xl" alt="ini gambar" />
                        </div>
                        <div className="w-2/3 px-12">
                            <h1 className="font-bold text-3xl text-start mb-2">{paketData.content}</h1>
                            <h1 className="font-bold text-2xl text-start mb-2 pt-4">Agenda Kegiatan</h1>
                            <ol className="text-start text-xl">
                                <li>1. Desa Banraas adalah salah satu nama desa yang.</li>
                                <li>2. Desa Banraas adalah salah satu nama desa yang.</li>
                                <li>3. Desa Banraas adalah salah satu nama desa yang.</li>
                                <li>4. Desa Banraas adalah salah satu nama desa yang.</li>
                                <li>5. Desa Banraas adalah salah satu nama desa yang.</li>
                                <li>6. Desa Banraas adalah salah satu nama desa yang.</li>
                                <li>7. Desa Banraas adalah salah satu nama desa yang.</li>
                            </ol>
                            <h1 className="font-bold text-2xl text-start mt-4 my-2">More Information</h1>
                            <div className="flex">
                                <a href="" className="mr-4">
                                    <img src={instagram} alt="" />
                                </a>
                                <a href="">
                                    <img src={youtube} alt="" />
                                </a>
                            </div>
                            <div className="text-start pt-8 font-bold text-2xl">
                                <h1>Jadwal Agenda</h1>
                            </div>
                            <div className="text-start pt-8 font-bold text-2xl">
                                <h1>Oleh-oleh yang akan didapatkan</h1>
                                <div className="mt-4 flex">
                                    <CardImage
                                        dataImage1={paketData.image_oleh_1}
                                        dataImage2={paketData.image_oleh_2}
                                        dataImage3={paketData.image_oleh_3}
                                        dataImage4={paketData.image_oleh_4}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default DetailPaketWisata;